import React, {useState, useEffect} from 'react'
import { faEdit, faCog, faChevronLeft, faTv } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import { icon } from '@fortawesome/fontawesome-svg-core';

const EditTopicLink = ({code, entry}) => {

    function back(){
        window.location = `/topic/edit/${code}`;
    }

    const styles = {
        links:{
            display: 'flex',
        },
        settingsLink:{
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            color: '#363636',
            marginRight: 20,
            fontSize: 14,
            fontWeight: 500,
            textDecoration: 'none',
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        previewLink:{
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            color: '#363636',
            marginRight: 20,
            fontSize: 14,
            fontWeight: 500,
            textDecoration: 'none',
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        icon:{
            marginRight: 5
        }
    }

    return (
        <div style={styles.links}>
            <div>
                {(entry == "settings") &&
                    <Link to={`/topic/edit/${code}`} style={styles.settingsLink}>
                        <FontAwesomeIcon icon={faEdit} style={styles.icon} />Edit
                    </Link>
                }

                {(entry == "edit") &&
                    <Link to={`/topic/settings/${code}`} style={styles.settingsLink}>
                        <FontAwesomeIcon icon={faCog} style={styles.icon} />Settings
                    </Link>
                }

            </div>
            <div>
                <a href={`/topic/${code}`}  style={styles.previewLink}>
                    <FontAwesomeIcon icon={faTv} style={styles.icon} />Preview
                </a>
            </div>
        </div>
    )
}

export default EditTopicLink